var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconoBorrar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.625,
    height: 20,
    viewBox: "0 0 17.625 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-trash-alt",
    "data-name": "Icon awesome-trash-alt",
    d: "M1.187,17.219A1.781,1.781,0,0,0,2.969,19H13.656a1.781,1.781,0,0,0,1.781-1.781V4.75H1.187Zm10.094-9.5a.594.594,0,0,1,1.187,0v8.312a.594.594,0,1,1-1.187,0Zm-3.563,0a.594.594,0,0,1,1.187,0v8.312a.594.594,0,1,1-1.187,0Zm-3.562,0a.594.594,0,0,1,1.187,0v8.312a.594.594,0,1,1-1.187,0ZM16.031,1.187H11.578L11.229.494a.891.891,0,0,0-.8-.494H6.19A.88.88,0,0,0,5.4.494l-.349.694H.594A.594.594,0,0,0,0,1.781V2.969a.594.594,0,0,0,.594.594H16.031a.594.594,0,0,0,.594-.594V1.781A.594.594,0,0,0,16.031,1.187Z",
    transform: "translate(0.5 0.5)",
    fill: "#c2c2c2",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoBorrar);
export default __webpack_public_path__ + "static/media/icono-borrar.061a5dbe3b10bccc315f6fb2c6d96511.svg";
export { ForwardRef as ReactComponent };